import { render, staticRenderFns } from "./salaryTongcheng.vue?vue&type=template&id=2ce2b0d5&scoped=true&"
import script from "./salaryTongcheng.vue?vue&type=script&lang=js&"
export * from "./salaryTongcheng.vue?vue&type=script&lang=js&"
import style0 from "./salaryTongcheng.vue?vue&type=style&index=0&id=2ce2b0d5&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce2b0d5",
  null
  
)

export default component.exports